import {Suspense} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {BlockUIProvider} from './modules/services/Bundle'
import './App.css'
import './Pro4Tech.css'
import '@availity/block-ui/src/BlockUi.css'
import '@availity/block-ui/dist/index.css'
import 'dropzone/dist/dropzone.css'
import { UpdateAuth } from './modules/auth/components/UpdateAuth'
import { ptBR } from '@mui/material/locale';
import { createTheme, ThemeProvider } from '@mui/material'

const theme = createTheme(ptBR);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <I18nProvider>
          <LayoutProvider>
            <BlockUIProvider>
              <UpdateAuth />
              <Outlet />    
              <MasterInit />         
            </BlockUIProvider>    
          </LayoutProvider>
        </I18nProvider>
      </Suspense>
    </ThemeProvider>
  )
}

export {App}